import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'emptyOrZeroToDash'})
export class emptyOrZeroToDashPipe implements PipeTransform {
  transform(value: string|null|undefined, prefix: string = '', sufix: string = ''): string {
    return Number(value) === 0 ? '-' : `${prefix}${value}${sufix}`;
  }
}
